module.exports = __webpack_public_path__ + "static/media/register-book-extended.b60b76b9.svg";